<lib-viz-footer
    [appName]="footerTitle"
    contactLink="mailto:suppliertraining@vizientinc.com"
    termsLink="https://vizientinc.com"
    copyright="Vizient Inc. All Rights Reserved."
></lib-viz-footer>